import { Routes } from '@angular/router';
import { HandleCardComponent } from './system/_handle-card/handle-card.component';
import { JumpinErrorComponent } from './system/_jumpin-error/jumpin-error.component';
import { LoginComponent } from './system/_login/login.component';
import { PageNotFoundComponent } from './system/_page-not-found/page-not-found.component';
import { SystemErrorComponent } from './system/_error/error.component';

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./panel/panel.routes').then(routes => routes.panelRoutes)
  },
  {
    path: 'Login',
    component: LoginComponent,
    data: {
      nosession: true
    }
  },

  {
    path: 'pay/:intentid',
    component: HandleCardComponent,
    data: {
      nosession: true
    }
  },
  {
    path: 'JumpInError',
    component: JumpinErrorComponent,
    data: {
      nosession: true
    }
  },
  {
    path: 'System/Error',
    component: SystemErrorComponent
  },
  { path: '**', component: PageNotFoundComponent, data: { nosession: true } },
];
